/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,no-undef */
import React from "react";
import SVG from "react-inlinesvg";
import { useAuthContext } from "../../../../../app/contexts/Auth";
import {toAbsoluteRouterUrl, toAbsoluteUrl} from "../../../../_helpers";
import { useMemo } from "react";
import { useFeatureAccessContext } from "../../../../../app/contexts/FeaturesAccess";
import { Link } from "@material-ui/core";
import { NavLink } from "react-router-dom/cjs/react-router-dom";

export function QuickUser() {

  const {auth, onSignOut, messagesTarget, messagesCount} = useAuthContext();
  const {config} = useFeatureAccessContext();

  const messagesController = useMemo(()=>{
    return config?.controllers?.find(controller => controller.name === messagesTarget);
  }, [messagesTarget, config]);

  const toggleOffCanvas = () => {
    const toggle = document.getElementById("kt_quick_user_toggle");
    if (toggle) {
      toggle.click();
    }    
  }

  const logoutClick = () => {
    toggleOffCanvas();
    onSignOut();
  };

  return (
      <div id="kt_quick_user" className="offcanvas offcanvas-right offcanvas p-10">
        <div className="offcanvas-header d-flex align-items-center justify-content-between pb-5">
          <h3 className="font-weight-bold m-0">
            Perfil de Usuario
            {/*<small className="text-muted font-size-sm ml-2">12 messages</small>*/}
          </h3>
          <a
              href="#"
              className="btn btn-xs btn-icon btn-light btn-hover-primary"
              id="kt_quick_user_close"
          >
            <i className="ki ki-close icon-xs text-muted"/>
          </a>
        </div>
        <div className="offcanvas-content pr-5 mr-n5">
          <div className="d-flex align-items-center mt-5">
            {/* 
            <div className="symbol symbol-100 mr-5">
              <div className="symbol-label" style={{
                backgroundImage: `url(${toAbsoluteUrl(
                    "/media/users/300_21.jpg"
                )})`
              }}/>
              <i className="symbol-badge bg-success"/>
            </div>
            
            */}
            <div className="d-flex flex-column">
              <a
                  href="#"
                  className="font-weight-bold font-size-h5 text-dark-75 text-hover-primary"
              >
                {auth.name}
              </a>
              <div className="text-muted mt-1">{auth.role}</div>
              <div className="navi mt-2">
                <a href="#" className="navi-item">
                <span className="navi-link p-0 pb-2">
                  <span className="navi-text text-muted text-hover-primary">
                    {auth.userName}
                  </span>
                </span>
                </a>
              </div>
              {/* <Link to="/logout" className="btn btn-light-primary btn-bold">
                Sign Out
              </Link> */}
              {/* <NavLink to="/Dev">dev</NavLink> */}
              {messagesCount > 0 && !!messagesController &&
              
                <div className="navi mt-2" onClick={toggleOffCanvas}>
                  <NavLink to={toAbsoluteRouterUrl(messagesController.url)} className="navi-item">
                    <span className="navi-link p-0 pb-6">
                      <span className="navi-text text-hover-primary">
                        {
                          messagesCount == 1 
                          ? "Tiene un mensaje nuevo."
                          : `Tiene ${messagesCount} mensajes nuevos.`
                        }
                      </span>
                      <div style={{
                        width: 6, 
                        height: 6, 
                        borderRadius: 3, 
                        backgroundColor: "red", 
                        marginBottom: 15,
                        marginLeft: -3,
                        zIndex: 1,
                      }}>

                      </div>
                    </span>
                  </NavLink>
                </div>
              }

              <button className="btn btn-light-primary btn-bold" onClick={logoutClick}>Salir</button>
            </div>
          </div>
          <div className="separator separator-dashed mt-8 mb-5"/>
          {/*
          <div className="navi navi-spacer-x-0 p-0">
            <a href="#" className="navi-item">
              <div className="navi-link">
                <div className="symbol symbol-40 bg-light mr-3">
                  <div className="symbol-label">
                  <span className="svg-icon svg-icon-md svg-icon-warning">
                    <SVG
                        src={toAbsoluteUrl(
                            "/media/svg/icons/Shopping/Chart-bar1.svg"
                        )}
                    ></SVG>
                  </span>
                  </div>
                </div>
                <div className="navi-text">
                  <div className="font-weight-bold">Bandeja de entradas</div>
                  <div className="text-muted">Mensajes y tareas</div>
                </div>
              </div>
            </a>
          </div>
          <div className="separator separator-dashed my-7"></div>
          <div>
            <h5 className="mb-5">Notificaciones recientes</h5>
            <div className="d-flex align-items-center bg-light-warning rounded p-5 gutter-b">
            <span className="svg-icon svg-icon-warning mr-5">
              <SVG
                  src={toAbsoluteUrl("/media/svg/icons/Home/Library.svg")}
                  className="svg-icon svg-icon-lg"
              ></SVG>
            </span>
              <div className="d-flex flex-column flex-grow-1 mr-2">
                <a
                    href="#"
                    className="font-weight-normal text-dark-75 text-hover-primary font-size-lg mb-1"
                >
                  Another purpose persuade
                </a>
                <span className="text-muted font-size-sm">Due in 2 Days</span>
              </div>
              <span className="font-weight-bolder text-warning py-1 font-size-lg">
              +28%
            </span>
            </div>
          </div>          
          */}

        </div>
      </div>
  );
}
